import styles from "./ServiceModal.module.scss";
import {IPublicTrainingCourse} from "../../../models/TrainingCourse";
import React from "react";
import {useSwipeable} from "react-swipeable";
import arrowLeft from "../../../assets/images/icons/arrow-left.svg";
import {getImageFromAuthServer} from "../../../helpers/image.helper";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";
import useDisableScroll from "../../../hooks/useDisableScroll";

interface IServiceModalProps {
    item: IPublicTrainingCourse;
    closeModalFn: () => void;
}

const config = {
    delta: 10,
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: false,
    rotationAngle: 0,
    swipeDuration: Infinity,
    touchEventOptions: {passive: true},
}

const ServiceModal: React.FC<IServiceModalProps> = ({item, closeModalFn}) => {
    useDisableScroll();
    const navigate = useNavigate();
    const {t} = useTranslation();

    const handlers = useSwipeable({
        onSwiped: (eventData) => {
            if (eventData.dir === "Down") {
                closeModalFn();
            }
        },
        ...config,
    });

    return (
        <div className={styles.container}>
            <div className={styles.modal}>
                <div {...handlers} onClick={closeModalFn} className={styles.arrow}>
                    <img src={arrowLeft} alt="arrow"/>
                    <svg width="138" height="4" viewBox="0 0 138 4" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <rect width="138" height="4" rx="2" fill="#343434"/>
                    </svg>
                </div>
                <div className={styles.wrapper}>
                    <div className={styles.image}
                         style={{backgroundImage: `url(${getImageFromAuthServer(item.image)})`}}></div>

                    <div className={styles.nameContainer}>
                        <p className={styles.name}>{item.name}</p>
                    </div>

                    <div>
                        <p className={`${styles.name} ${styles.fs18} ${styles.description}`}>{t('Description')}</p>
                        <div className={`${styles.descriptionText} ${styles.description} ${styles.mt15}`}>
                            <p>{item.description}</p>
                        </div>
                    </div>

                    <div className={styles.detailsContainer}>

                        <div className={`${styles.detail} ${styles.borderRight}`}>
                            <p className={`${styles.name} ${styles.fs18}`}>{t('Duration')}</p>
                            <p className={styles.descriptionText}>{item.duration}</p>
                        </div>

                        <div className={`${styles.detail} ${styles.borderRight}`}>
                            <p className={`${styles.name} ${styles.fs18}`}>{t('Instructor')}</p>
                            <p className={styles.descriptionText}>{item.instructor.profile.firstname} {item.instructor.profile.lastname}</p>
                        </div>
                        <div className={styles.detail}>
                            <p className={`${styles.name} ${styles.fs18}`}>{t('RoomCapacity')}</p>
                            <p className={styles.descriptionText}>{item.capacity}</p>
                        </div>
                    </div>

                    <div className={styles.mt15}>
                        <CustomButton
                            text={t("Book")}
                            type={"button"}
                            typeStyle={"fill"}
                            borderRadius={false}
                            functionOnClick={() => navigate("/schedule")}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceModal;